/* Main customizer stage: rotation and artwork editing are separate gestures.
 * The measurable print DOM stays in place even while its 360 sibling is visible. */
(function () {
  'use strict';
  const $=s=>document.querySelector(s);
  let root, host, nav, original, canvas, viewer, timer, observer, resize, intersection;
  let active=false, wanted=false, suspended=false, visible=true, revision=0, lastProfile=null, lastSignature=null;
  const bridge=()=>window.RoboPixel360.transfer;
  const message=key=>{const el=$('[data-inline-360-status]');if(el){el.textContent=key?bridge().config().copy[key]:'';el.hidden=!key;}};
  function syncControls() {
    $('[data-inline-design]')?.setAttribute('aria-pressed',String(!active));
    $('[data-inline-360]')?.setAttribute('aria-pressed',String(active));
    $('[data-inline-360-hint]').hidden=!active;
    root.dataset.inlineView=active?'360':'design';
    host.hidden=!active;
    viewer?.setActive(active&&!suspended&&visible);
    const turns=$('[data-inline-360-turns]');if(turns)turns.hidden=!active;
  }
  function edit() {
    const changed=active;
    revision++; clearTimeout(timer); active=false; wanted=false; lastSignature=null; syncControls(); message('');
    if(changed)window.RoboPixelJourney?.refresh();
  }
  async function show() {
    const p=bridge().profile();if(!p){edit();return;}
    wanted=true;
    const entering=!active, ticket=++revision;
    if(entering)message('loading');
    lastSignature=bridge().signature?.();
    try {
      const [texture,renderer]=await Promise.all([bridge().capture(),bridge().loadRenderer(p)]);
      if(!texture||ticket!==revision||p!==bridge().profile())return;
      if(!viewer){
        const target=document.createElement('canvas'); target.className='cz-preview-360-canvas';
        target.tabIndex=0; target.setAttribute('aria-label',bridge().config().copy.hint);
        target.addEventListener('contextmenu',e=>e.preventDefault());
        target.addEventListener('robopixel:360-change',()=>bridge().syncRotationControls('inline',viewer));
        target.addEventListener('robopixel:360-error',()=>{edit();viewer?.dispose();viewer=null;canvas=null;target.remove();message('error');});
        const candidate=await renderer.create(target,bridge().assets(p).photos);
        if(ticket!==revision||p!==bridge().profile()){candidate.dispose();return;}
        viewer=candidate;canvas=target;host.appendChild(canvas);
      }
      viewer.setArtwork(texture);active=true;message('');
      // Only mode entry changes layout. Texture refreshes must not re-dismiss the
      // gesture coach or refresh the journey: those mutations used to re-trigger
      // this observer indefinitely and flash the loading message every 100ms.
      if(entering){
        viewer.setAutoRotate?.(!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
        syncControls();
        window.RoboPixelJourney?.refresh();
        window.RoboPixelJourney?.announce?.('');
        if(typeof dismissGestureCoach==='function')dismissGestureCoach();
      }
      lastSignature=bridge().signature?.();
      bridge().syncRotationControls?.('inline',viewer);
      canvas.dataset.profile=bridge().profile().file;
      if(p.name)canvas.dataset.model=p.name;
    }catch(error){if(ticket!==revision)return;edit();message('error');console.warn('[RoboPixel inline 360]',error.message);}
  }
  function schedule() {
    const p=bridge().profile(); nav.hidden=!p;
    if(p!==lastProfile){lastProfile=p;edit();viewer?.dispose();viewer=null;canvas?.remove();canvas=null;return;}
    if(!wanted||suspended)return;
    if(lastSignature!==null&&bridge().signature&&lastSignature===bridge().signature())return;
    revision++;clearTimeout(timer);timer=setTimeout(show,100);
  }
  function init() {
    root=$('[data-product-stage]');host=$('[data-inline-360-stage]');nav=$('[data-inline-360-modes]');original=$('#mockup-container');
    if(!root||!host||!nav||!original||root.dataset.inlineReady)return;
    root.dataset.inlineReady='true';lastProfile=bridge().profile();nav.hidden=!lastProfile;
    $('[data-inline-design]').onclick=edit;$('[data-inline-360]').onclick=show;
    bridge().bindRotationControls?.('inline',()=>viewer);
    observer=new MutationObserver(schedule);
    observer.observe(original,{attributes:true,subtree:true,attributeFilter:['src','srcset','style','class','data-model']});
    resize=new ResizeObserver(schedule);resize.observe(original);
    $('#design-image').addEventListener('load',schedule);$('#mockup-overlay').addEventListener('load',schedule);
    if('IntersectionObserver' in window){intersection=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;viewer?.setActive(active&&!suspended&&visible);});intersection.observe(root);}
    syncControls();
  }
  window.RoboPixel360Inline={edit,isActive:()=>active,rotateBy(delta){if(active)viewer?.rotateBy?.(delta);},suspend(){suspended=true;viewer?.setActive(false);},resume(){suspended=false;if(active){viewer?.setActive(visible);schedule();}}};
  window.addEventListener('pagehide',()=>{revision++;clearTimeout(timer);viewer?.dispose();viewer=null;canvas?.remove();canvas=null;active=false;});
  if(typeof window.RoboPixelCustomizerReady==='function')window.RoboPixelCustomizerReady(init);
  else document.addEventListener('robopixel:customizer-ready',init,{once:true});
})();
